import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import { IAnalysisState } from '@/modules/analysis/store/state';
import {
  FiduciaryAnalysis,
  FundAnalysis,
  OrganisationAnalysis,
  Paginated,
  PaginatedV2,
  SchemeAnalysis,
  SubfundAnalysis,
  SubmissionSummary
} from '@/modules/analysis/types';
/**
 * --------------------------------------------------
 * Analysis Getters
 * --------------------------------------------------
 **/
export const AnalysisGetters: IAnalysisGetters = {
  fetchingFundAnalysis: (state: IAnalysisState): boolean =>
    state.fetchingFundAnalysis,
  fundAnalysis: (state: IAnalysisState): Paginated<FundAnalysis> | undefined =>
    state.fundAnalysis,
  schemeAnalysis: (
    state: IAnalysisState
  ): PaginatedV2<SchemeAnalysis> | undefined => state.schemeAnalysis,
  submissionSummary: (state: IAnalysisState): SubmissionSummary | undefined =>
    state.submissionSummary,
  subfundAnalysis: (
    state: IAnalysisState
  ): PaginatedV2<SubfundAnalysis> | undefined => state.subfundAnalysis,
  consultantAnalysis: (
    state: IAnalysisState
  ): OrganisationAnalysis | undefined => state.consultantAnalysis,
  providerAnalysis: (state: IAnalysisState): OrganisationAnalysis | undefined =>
    state.providerAnalysis,
  fiduciaryAnalysis: (
    state: IAnalysisState
  ): PaginatedV2<FiduciaryAnalysis> | undefined => state.fiduciaryAnalysis
};

/**
 * --------------------------------------------------
 *	 Analysis Getters Interface
 * --------------------------------------------------
 **/
export interface IAnalysisGetters
  extends GetterTree<IAnalysisState, IRootState> {
  fetchingFundAnalysis(state: IAnalysisState): boolean;
  fundAnalysis(state: IAnalysisState): Paginated<FundAnalysis> | undefined;
  schemeAnalysis(
    state: IAnalysisState
  ): PaginatedV2<SchemeAnalysis> | undefined;
  submissionSummary(state: IAnalysisState): SubmissionSummary | undefined;
  subfundAnalysis(
    state: IAnalysisState
  ): PaginatedV2<SubfundAnalysis> | undefined;
  consultantAnalysis(state: IAnalysisState): OrganisationAnalysis | undefined;
  providerAnalysis(state: IAnalysisState): OrganisationAnalysis | undefined;
  fiduciaryAnalysis(
    state: IAnalysisState
  ): PaginatedV2<FiduciaryAnalysis> | undefined;
}
